/* eslint-disable */
export function saveFile(filename, base64text, mimeType, sliceSize) {
  function BlobConverter() {
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512
      const byteCharacters = atob(b64Data) // atob ����һ��Base64�ַ�����
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        // Uint8Array �������ͱ�ʾһ��8λ�޷����������飬����ʱ���ݱ���ʼ��Ϊ0��
        // ������󣬿����Զ���ķ�ʽ��ʹ�������±������ķ�ʽ���������е�Ԫ�ء�
        const byteArray = new Uint8Array(byteNumbers) // ����Ԫ���ֽ�
        byteArrays.push(byteArray)
      }
      // Blob ����� type ���Ը����ļ��� MIME ����
      const blob = new Blob(byteArrays, { type: contentType }) // ��Ŷ���������
      return blob
    }
    this.getBlob = function(base64text, mimeType, sliceSize) {
      return b64toBlob(base64text, mimeType, sliceSize)
    }
  }
  const blobConverter = new BlobConverter()
  const blob = blobConverter.getBlob(base64text, mimeType, sliceSize)
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(blob) // ���ݴ���Ĳ��������µ�url
    link.style.diaplay = 'none'
    link.download = filename
    link.href = url
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url) // �ͷ�url
    link.remove()
  }
}
